import {Module, NextModule} from '@backstage-components/base';
import React from 'react';
import {
  PeacockBackgroundComponent,
  PeacockBackgroundComponentDefinition,
} from './PeacockBackgroundComponent';
import {ComponentDefinition} from './PeacockBackgroundDefinition';

type Kind = PeacockBackgroundComponentDefinition['component'];

type Props = PeacockBackgroundComponentDefinition['props'];

export const PeacockBackgroundModule: Module<Kind, Props> = {
  isContent(value): value is PeacockBackgroundComponentDefinition {
    return false;
  },
  isLayout(value): value is PeacockBackgroundComponentDefinition {
    return (
      value.component === ComponentDefinition.reactName &&
      value.cid === ComponentDefinition.id
    );
  },
  tryRender(definition) {
    if (PeacockBackgroundModule.isContent(definition)) {
      return React.createElement(PeacockBackgroundComponent, definition);
    } else {
      return NextModule;
    }
  },
};
